// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* License Hub – tabbed layout so content is not congested */

.license-hub {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  max-width: none;
}

.license-hub-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  padding: 4px;
  background: #f1f5f9;
  border-radius: 12px;
  width: fit-content;
  border: 1px solid #e2e8f0;
}

.license-hub-tab {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.license-hub-tab:hover {
  color: #334155;
  background: #e2e8f0;
}

.license-hub-tab.active {
  background: #fff;
  color: #2563eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.license-hub-content {
  flex: 1 1;
  min-height: 0;
}

/* Each tab panel is full width */
.license-hub-content > * {
  width: 100%;
}

/* Hide duplicate page title when shown inside hub (tab bar is the title) */
.license-hub-content .crud-page > .crud-header {
  display: none;
}

@media (max-width: 768px) {
  .license-hub-tabs {
    flex-wrap: wrap;
    width: 100%;
  }
  .license-hub-tab {
    flex: 1 1 auto;
    min-width: 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LicenseHub.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":["/* License Hub – tabbed layout so content is not congested */\n\n.license-hub {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  max-width: none;\n}\n\n.license-hub-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 20px;\n  padding: 4px;\n  background: #f1f5f9;\n  border-radius: 12px;\n  width: fit-content;\n  border: 1px solid #e2e8f0;\n}\n\n.license-hub-tab {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748b;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.license-hub-tab:hover {\n  color: #334155;\n  background: #e2e8f0;\n}\n\n.license-hub-tab.active {\n  background: #fff;\n  color: #2563eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.license-hub-content {\n  flex: 1;\n  min-height: 0;\n}\n\n/* Each tab panel is full width */\n.license-hub-content > * {\n  width: 100%;\n}\n\n/* Hide duplicate page title when shown inside hub (tab bar is the title) */\n.license-hub-content .crud-page > .crud-header {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .license-hub-tabs {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n  .license-hub-tab {\n    flex: 1 1 auto;\n    min-width: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
